var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferenceIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 200,
    viewBox: "0 0 199 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1649_20616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5 197.518C154.043 197.518 198.259 153.302 198.259 98.759C198.259 44.2159 154.043 0 99.5 0C44.9569 0 0.740967 44.2159 0.740967 98.759C0.740967 153.302 44.9569 197.518 99.5 197.518Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2152 40.3654C92.2152 40.3654 95.8921 34.0457 101.942 33.4367C107.991 32.8278 118.137 31.8281 122.297 41.388C125.388 48.4833 130.173 47.7939 132.989 51.241C135.493 54.3031 135.752 56.0554 135.809 61.7833C135.89 69.4416 134.057 69.3152 137.539 73.8194C137.539 73.8194 144.318 80.3746 142.882 88.0271C141.445 95.6797 139.297 98.3511 141.399 103.642C143.502 108.934 146.794 109.232 144.416 115.127C142.186 120.665 142.56 123.055 142.715 124.762C143.232 130.512 141.957 134.747 140.739 136.895C139.521 139.044 97.8397 133.724 97.8397 133.724C97.8397 133.724 55.9404 129.059 53.9008 128.117C51.8613 127.175 47.7305 121.2 51.5453 113.702C55.3601 106.205 56.5838 109.853 57.4341 98.5695C58.2844 87.286 61.5763 88.2454 64.6672 82.4026C67.7581 76.5598 68.3154 78.9728 69.137 69.1313C69.9585 59.2899 69.9815 54.3491 74.8419 49.1267C81.4718 42.0028 91.1696 42.9162 92.2095 40.3711L92.2152 40.3654Z",
    fill: "#1F2025",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3207 113.306L90.6008 97.3572L105.642 94.9902L111.99 113.306L111.766 121.47L92.9908 124.716L86.3207 113.306Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3206 113.306C86.3206 113.306 64.0984 113.92 60.14 118.902C56.1816 123.883 51.7521 140.595 51.7521 140.595L70.4927 145.255L65.8622 174.285L138.05 173.411L130.259 146.628L145.915 140.612C145.915 140.612 140.176 127.221 137.981 121.855C135.516 115.822 131.437 115.19 125.83 114.34C122.096 113.771 111.99 113.294 111.99 113.294C111.99 113.294 110.571 118.35 103.929 120.309C96.6446 122.458 89.7677 121.131 86.3149 113.294L86.3206 113.306Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.069 98.6959C106.021 99.4887 111.76 92.6003 114.719 86.8551C118.821 78.8866 119.821 69.8035 119.821 69.8035C119.821 69.8035 121.659 59.4335 117.08 53.9067C117.08 53.9067 115.667 51.7982 112.243 54.6708C109.939 56.6012 107.744 55.4579 106.113 56.4231C104.211 57.5491 103.895 59.8357 101.718 61.249C99.4138 62.7427 99.3851 61.4443 97.0181 62.9323C96.0242 63.5585 95.0475 65.5866 93.6859 66.8103C92.2381 68.1087 90.888 68.1834 89.8941 68.7292C89.8941 68.7292 87.9522 65.6728 86.5447 66.2128C85.1371 66.7528 83.0631 69.1601 84.6775 73.2678C85.9472 76.5139 87.8431 76.3875 87.8431 76.3875C87.5845 76.083 87.2743 82.5692 88.274 87.3607C89.1013 91.3248 90.3824 97.4032 100.074 98.6959H100.069Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.511 81.3455L104.108 82.1441C104.608 82.2992 105.136 82.0292 105.297 81.5294C105.952 79.4956 107.606 72.8025 108.842 67.787",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.511 81.3455L104.108 82.1441C104.608 82.2992 105.136 82.0292 105.297 81.5294C105.952 79.4956 107.606 72.8025 108.842 67.787",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.459 69.7288C101.879 69.7863 101.356 69.3611 101.293 68.7809C101.229 68.2006 101.66 67.6778 102.24 67.6146C102.821 67.5514 103.344 67.9823 103.407 68.5683C103.47 69.1543 103.039 69.6714 102.459 69.7346V69.7288Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.306 71.866C112.725 71.9235 112.203 71.4983 112.139 70.9123C112.076 70.3263 112.507 69.8093 113.087 69.7461C113.673 69.6886 114.19 70.1138 114.254 70.694C114.317 71.2743 113.886 71.7971 113.3 71.8603L113.306 71.866Z",
    fill: "#1F2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1151 87.3607C99.1151 87.3607 101.689 87.9812 105.159 87.5273L99.1151 87.3607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1151 87.3607C99.1151 87.3607 101.689 87.9812 105.159 87.5273",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5905 141.055C53.5905 141.055 52.384 146.07 50.8961 154.401C50.4422 156.929 49.9079 162.961 54.9579 164.777C60.0079 166.592 70.6076 171.527 79.4782 158.939C83.9594 152.574 84.35 144.025 101.781 113.208C102.413 112.088 103.246 111.094 104.228 110.272C105.268 109.405 106.865 108.124 109.158 106.417C113.846 102.93 113.932 100.799 113.932 99.3048C113.932 97.8111 112.335 97.61 112.237 97.3113C112.145 97.0298 112.036 95.5705 110.335 95.289C110.117 95.2545 109.945 95.0936 109.876 94.8811C109.669 94.2089 109.043 92.8473 107.336 92.8703C107.089 92.8703 106.865 92.7152 106.785 92.4796C106.463 91.6006 105.929 89.8541 103.631 90.509C103.631 90.509 102.867 90.779 102.097 91.6753C101.327 92.5715 97.7592 96.6563 96.4148 96.5242C95.0705 96.392 91.0891 91.8534 90.7214 91.6868C90.302 91.4972 88.9232 91.6868 88.6244 92.7784C88.4463 93.4333 88.205 94.0021 90.0262 96.1105C91.8475 98.219 93.1573 100.155 93.3412 101.241C93.4733 102.011 93.4101 105.079 91.2097 108.463C90.3882 109.727 77.7316 129.714 69.2575 143.043C67.7466 145.421 65.5921 148.828 65.2187 149.351L68.2694 144.617",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5905 141.055C53.5905 141.055 52.384 146.07 50.8961 154.401C50.4422 156.929 49.9079 162.961 54.9579 164.777C60.0079 166.592 70.6076 171.527 79.4782 158.939C83.9594 152.574 84.35 144.025 101.781 113.208C102.413 112.088 103.246 111.094 104.228 110.272C105.268 109.405 106.865 108.124 109.158 106.417C113.846 102.93 113.932 100.799 113.932 99.3048C113.932 97.8111 112.335 97.61 112.237 97.3113C112.145 97.0298 112.036 95.5705 110.335 95.289C110.117 95.2545 109.945 95.0936 109.876 94.8811C109.669 94.2089 109.043 92.8473 107.336 92.8703C107.089 92.8703 106.865 92.7152 106.785 92.4796C106.463 91.6006 105.929 89.8541 103.631 90.509C103.631 90.509 102.867 90.779 102.097 91.6753C101.327 92.5715 97.7592 96.6563 96.4148 96.5242C95.0705 96.392 91.0891 91.8534 90.7214 91.6868C90.302 91.4972 88.9232 91.6868 88.6244 92.7784C88.4463 93.4333 88.205 94.0021 90.0262 96.1105C91.8474 98.219 93.1573 100.155 93.3412 101.241C93.4733 102.011 93.4101 105.079 91.2097 108.463C90.3882 109.727 77.7316 129.714 69.2575 143.043C67.7466 145.421 65.5921 148.828 65.2187 149.351L68.2694 144.617",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.703 173.228H5.29688V199.782H193.703V173.228Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7771 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3204 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8695 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.413 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.962 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5054 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0546 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5979 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1471 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6904 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2395 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.783 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.332 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.875 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.425 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.968 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.517 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.066 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.609 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.159 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.702 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.251 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.795 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.344 173.228V199.782",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2866 145.973H39.6184V191.641H85.2866V145.973Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6723 146.174H58.2384V162.162H66.6723V146.174Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.371 133.793H114.524V191.641H172.371V133.793Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.788 134.051H138.107V154.309H148.788V134.051Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.201 178.461H147.374V187.154H167.201V178.461Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6962 180.093H64.5811V187.16H80.6962V180.093Z",
    fill: "#C1E8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1649_20616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197.518,
    height: 200,
    fill: "white",
    transform: "translate(0.740967)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceIndex);
export default __webpack_public_path__ + "static/media/reference_index.795bf2dddfd56940696bc76e02af744b.svg";
export { ForwardRef as ReactComponent };